import React, { ComponentProps } from "react";

import SelectPickerInput from "../../components/Common/SelectPickerInput/SelectPickerInput";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { useFieldContext } from "../formContext";

type FormSelectProps = Omit<ComponentProps<typeof SelectPickerInput>, "name" | "value" | "onChange">;

/**
 * Adapter: web's `SelectPickerInput` bound to the current field. The field value must be the picked
 * `string | number | null`; `useFieldContext<V>` is not checked against the form. Not wired to blur.
 */
export const FormSelect: React.FC<FormSelectProps> = (props) => {
  const field = useFieldContext<string | number | null>();

  return (
    <>
      <SelectPickerInput
        {...props}
        name={field.name}
        value={field.state.value}
        onChange={(value: string | number | null) => field.handleChange(value)}
      />
      <FieldErrorMessage />
    </>
  );
};
